import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flash",
  "use": "icon-flash-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-flash\"><path d=\"M574.73113 430.376812H808.811594L393.275362 1011.014493l55.993508-430.376812H215.188406L630.724638 0l-55.993508 430.376812z\" fill=\"#1296db\" p-id=\"4997\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol